export type DynamicOrStaticProperty<OutType, Args> =
  | OutType
  | ((a: Args) => OutType);

/**
 * Resolves the value of a property. If the property is a function it is invoked. If the property is not a function then the value is returned
 * 
 * @param property 
 * @param args 
 * @returns 
 */
export function resolveDynamicOrStaticProperty<OutType, Args>(
  property: DynamicOrStaticProperty<OutType, Args>,
  args: Args
): OutType {
  if (typeof property === 'function') {
    return (property as (a: Args) => OutType)(args);
  }
  return property;
}
